import { render, staticRenderFns } from "./FollowDialog.vue?vue&type=template&id=308603ac&scoped=true"
import script from "./FollowDialog.vue?vue&type=script&lang=js"
export * from "./FollowDialog.vue?vue&type=script&lang=js"
import style0 from "./FollowDialog.vue?vue&type=style&index=0&id=308603ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308603ac",
  null
  
)

export default component.exports